import React, { useState, useEffect } from "react"
import jamIsPublic from "../util/fetchApiHelpers/jamIsPublic"
import authAndGetUser from "../util/fetchApiHelpers/authAndGetUser"
import sendUserOtp from "../util/fetchApiHelpers/sendUserOtp"
import authUser from "../util/fetchApiHelpers/authUser"

export interface LoginModalProps {
	JAM_ID: string
	onAuthenticated: () => void
	onClose: () => void
}

export default function LoginModal(props: LoginModalProps) {
	let { JAM_ID } = props

	let [email, setEmail] = useState("")
	let [otp, setOtp] = useState("")
	let [signingInStage, setSigningInState] = useState(0)
	let [isPublicJam, setIsPublicJam] = useState(false)

	useEffect(() => {
		let cancelled = false
		jamIsPublic(JAM_ID).then((res) => {
			if (!cancelled) {
				setIsPublicJam(res)
			}
		})
		return () => {
			cancelled = true
		}
	}, [JAM_ID])

	function handleEmailChange(event: React.ChangeEvent<HTMLInputElement>) {
		setEmail(event.currentTarget.value)
	}

	function handleOtpChange(event: React.ChangeEvent<HTMLInputElement>) {
		setOtp(event.currentTarget.value)
	}

	async function handleSubmit(event: React.FormEvent) {
		event.preventDefault()

		if (isPublicJam) {
			// get user
			await authAndGetUser(JAM_ID, email)
			props.onAuthenticated()
		} else {
			// get user otp and show otp input
			// if no otp submitted yet, then time to tell the user about the otp and send them one
			if (otp.length == 0) {
				setSigningInState((stage) => stage + 1)
				await sendUserOtp(JAM_ID, email)
			} else {
				// submit otp and log in user
				await authUser(JAM_ID, otp, email)
				props.onAuthenticated()
			}
		}
	}

	return (
		<div className="wrapper">
			<div className="login-modal-wrapper">
				<img
					onClick={props.onClose}
					className="close"
					src="https://danigrant.github.io/img/close.svg"
				/>
				<a href="https://jam.dev" target="_blank" rel="noopener noreferrer">
					<img
						className="graphic"
						src="https://strawberry-jam-manufacturers.github.io/img/logo.png"
					/>
				</a>
				{signingInStage === 0 && <h1>Let’s get you jamming!</h1>}
				{signingInStage === 1 && (
					<h1>{"One last step and then you're in the jam."}</h1>
				)}
				{signingInStage === 0 && (
					<h2>
						Enter your email to{" "}
						<a href="https://jam.dev" target="_blank" rel="noopener noreferrer">
							jam
						</a>{" "}
						with your crew.
					</h2>
				)}
				{signingInStage === 1 && <h2>{`Enter the code sent to ${email}.`}</h2>}
				<form onSubmit={handleSubmit}>
					{signingInStage === 0 && (
						<input
							type="email"
							placeholder={`you@${window.location.hostname.replace(
								"www.",
								"",
							)}`}
							value={email}
							onChange={handleEmailChange}
						/>
					)}
					{signingInStage === 1 && (
						<input
							type="text"
							placeholder="Code was sent to your email"
							value={otp}
							onChange={handleOtpChange}
						/>
					)}
					{signingInStage === 0 && <button type="submit">{"Let's jam"}</button>}
					{signingInStage === 1 && <button type="submit">High five</button>}
				</form>
			</div>
			<div onClick={props.onClose} className="overlay"></div>
			<style>{`
				.overlay {
					background: rgba(0, 0, 0, 0.5);
					position: fixed;
					z-index: 1000001;
					width: 100%;
					height: 100vh;
					top: 0;
					left: 0;
				}

				.login-modal-wrapper {
					display: flex;
					flex-direction: column;
					width: 630px;
					max-width: 90%;
					justify-content: center;
					height: fit-content;
					position: fixed;
					top: 0;
					bottom: 0;
					left: 0;
					right: 0;
					margin: auto;
					z-index: 1000002;
					background: #ffffff;
					box-sizing: border-box;
					box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
					border-radius: 2px;
					overflow: hidden;
					font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
						"Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
						"Helvetica Neue", sans-serif;
					color: #2a3632;
					padding: 3em 3.5em;
				}

				a {
					color: #9194ff;
					cursor: pointer;
					text-decoration: none;
				}

				h1 {
					font-size: 2em;
				}

				h2 {
					font-weight: 400;
					color: rgba(42, 54, 50, 0.5);
					margin-top: 0;
					font-size: 18px;
				}

				form {
					display: flex;
					flex-direction: column;
					max-width: 100%;
				}

				input {
					width: 100%;
					outline: none;
					border: none;
					font-size: inherit;
					color: inherit;
					padding: 1em;
					margin-top: 1em;
					background: #f4f4f4;
					box-sizing: border-box;
					border-radius: 2px;
					border: 1px solid #e2e2e2;
				}

				button {
					width: 100%;
					height: 50px;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					background: #3776fd;
					border-radius: 5px;
					border: none;
					outline: none;
					color: white;
					font-weight: 500;
					font-size: 1em;
					margin: 2rem 0;
					margin-bottom: 1em;
					cursor: pointer;
				}

				.graphic {
					width: 60px;
				}

				.close {
					position: absolute;
					top: 1em;
					right: 1em;
					cursor: pointer;
				}
			`}</style>
		</div>
	)
}
